import React from "react";
import { Reveal } from "./ui";

/** Very short bridge straight into the price block. */
export function OfferTransition() {
  return <section className="w-full bg-[#eef6ff] px-4 py-10 sm:px-8 sm:py-14" data-id="element-153" data-mp="1w2dzfg7kshe7">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-154" data-mp="206lpbgprs3e0">
        <h2 className="font-serif-display text-[1.6rem] font-semibold leading-tight tracking-[-0.02em] text-[var(--ink)] sm:text-3xl" data-id="element-155" data-mp="254n800jaa0oy">
          Todo lo que necesitás, en un solo lugar.
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-[var(--muted)] sm:text-base" data-id="element-156" data-mp="1cfy3drj0rd8g">
          6 guías + 3 recursos complementarios para volver a consultar cada vez que necesites
          nuevas ideas o un punto de partida.
        </p>
      </Reveal>
    </section>;
}